"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = Button;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const antd_1 = require("antd");
const polished_1 = require("polished");
const Link_1 = require("../Link");
const defaultProps = {
    size: 'large',
    type: 'primary',
    textStyle: 'default',
};
function Button(props) {
    const { children, link, type, size, ref, textStyle, warning, ...otherProps } = { ...defaultProps, ...props };
    if (type === 'secondary' || props.type === 'secondary') {
        return ((0, jsx_runtime_1.jsx)(StyledSecondaryButtonWrapper, { size: size, textStyle: textStyle, ref: ref, disabled: props.disabled, children: (0, jsx_runtime_1.jsx)(antd_1.Button, { type: "default", size: size, ...otherProps, children: children }) }));
    }
    if (type === 'success' || props.type === 'success') {
        return ((0, jsx_runtime_1.jsx)(SuccessButton, { size: size, textStyle: textStyle, ref: ref, ...otherProps, children: children }));
    }
    if (warning) {
        return ((0, jsx_runtime_1.jsx)(WarningButton, { size: size, textStyle: textStyle, ref: ref, ...otherProps, children: children }));
    }
    if (link) {
        return ((0, jsx_runtime_1.jsx)(StyledLink, { to: link, ref: ref, children: (0, jsx_runtime_1.jsx)(antd_1.Button, { type: props.type || 'default', size: size, ...otherProps, children: children }) }));
    }
    return ((0, jsx_runtime_1.jsx)(antd_1.Button, { ref: ref, type: type, size: size, ...otherProps, children: children }));
}
const StyledLink = (0, styled_components_1.default)(Link_1.Link) `
	width: fit-content;
	height: fit-content;
`;
const StyledSecondaryButtonWrapper = styled_components_1.default.div `
	.ant-btn {
		border: none;
		background: ${({ theme }) => theme.color.gray2};
		color: ${({ theme, disabled }) => (disabled ? theme.color.gray6 : theme.color.brand1)};
		font-size: 14px;
		transition: all ${({ theme }) => theme.transition.basic};
		${({ textStyle }) => textStyle === 'upper-case-bold' &&
    (0, styled_components_1.css) `
				font-weight: bold;
				text-transform: uppercase;
			`}
		${({ size }) => !size &&
    (0, styled_components_1.css) `
				height: 2rem;
			`}

		&:hover {
			color: ${({ theme, disabled }) => (disabled ? theme.color.gray6 : theme.color.brand1)};
			background: ${({ theme, disabled }) => (disabled ? theme.color.gray2 : theme.color.gray4)};
		}
	}
`;
const SuccessButton = (0, styled_components_1.default)(Button) `
	background: ${({ theme }) => theme.color.success};
	border: 1px solid ${({ theme }) => theme.color.success};

	&:hover,
	&:focus {
		background: ${({ theme }) => (0, polished_1.transparentize)(0.1, theme.color.success)};
		border: 1px solid ${({ theme }) => theme.color.success};
	}
`;
const WarningButton = (0, styled_components_1.default)(Button) `
	background: ${({ theme }) => theme.color.warning};
	border: 1px solid ${({ theme }) => theme.color.warning};

	&:hover,
	&:focus {
		background: ${({ theme }) => (0, polished_1.transparentize)(0.1, theme.color.success)};
		border: 1px solid ${({ theme }) => theme.color.success};
	}
`;
